module.exports = __webpack_public_path__ + "688752abdb27670bb3cc8c8334754f16.svg";